import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@/assets/icons/search-md.svg?react';
import styles from './search-field.module.scss';

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  label?: string;
  className?: string;
}

export default function SearchField({
  value,
  onChange,
  placeholder,
  label,
  className,
}: SearchFieldProps) {
  const { t } = useTranslation('common');

  return (
    <div className={clsx(styles.field, className)}>
      <SearchIcon aria-hidden="true" className={styles.icon} />
      <input
        aria-label={label ?? t('actions.search')}
        className={styles.input}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        type="search"
        value={value}
      />
    </div>
  );
}
